import { useContext, useMemo, useState } from "react";
import { Context } from "../../../context/Context";
import { Button, ListCheck } from "../../ui";
import { getCampaignText } from "./campaignActionsText";
import CampaignModal from "./CampaignModal";
import CampaignRequestsModal from "./CampaignRequestsModal";
import StatusBadge from "./StatusBadge";

// One list of every campaign that has Operations requests (campaigns with none
// are left out). Picking an entry shows that campaign's existing detailed
// request status, with a way back to the list.
//   campaigns: [{ id, app, type, title, appLabel }]   byCampaign: requests by campaign id
export default function CampaignStatusOverviewModal({ campaigns, byCampaign, storeNames, canEdit, onClose, onChanged, onViewInOperations }) {
  const { lang } = useContext(Context);
  const text = getCampaignText(lang);
  const [selectedId, setSelectedId] = useState("");

  const entries = useMemo(() => campaigns.filter((campaign) => (byCampaign[campaign.id] || []).length > 0), [campaigns, byCampaign]);
  const selected = entries.find((campaign) => campaign.id === selectedId);

  if (selected) {
    return (
      <CampaignRequestsModal
        campaign={selected}
        requests={byCampaign[selected.id] || []}
        storeNames={storeNames}
        canEdit={canEdit}
        onClose={onClose}
        onBack={() => setSelectedId("")}
        onChanged={onChanged}
        onViewInOperations={onViewInOperations}
      />
    );
  }

  return (
    <CampaignModal
      title={text.statusOverviewTitle}
      icon={<ListCheck size={20} aria-hidden="true" />}
      onClose={onClose}
      closeLabel={text.close}
      footer={
        <Button variant="neutral" appearance="soft" onClick={onClose}>
          {text.close}
        </Button>
      }
    >
      {entries.length === 0 ? (
        <p className="ca-picker-state">{text.noCampaignsWithStatus}</p>
      ) : (
        <ul className="ca-request-list">
          {entries.map((campaign) => {
            const requests = byCampaign[campaign.id];
            const statuses = [...new Set(requests.map((request) => request.status))];
            return (
              <li key={campaign.id}>
                <button type="button" className="ca-status-entry" onClick={() => setSelectedId(campaign.id)}>
                  <span className="ca-status-entry-main">
                    <span className="ca-request-store">{campaign.title}</span>
                    <span className="ca-multi-hint">
                      {campaign.appLabel} · {text.requestsCount(requests.length)}
                    </span>
                  </span>
                  <span className="ca-status-entry-badges">
                    {statuses.map((status) => (
                      <StatusBadge key={status} status={status} />
                    ))}
                  </span>
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </CampaignModal>
  );
}
